<template>
  <div>
    <Message
      v-for="(message, index) in messages"
      :key="index"
      :message="message"
    />
  </div>
</template>

<style scoped>
.v-alert {
  margin-bottom: 0;
}
</style>

<script>
import Message from "@/components/Message";

export default {
  name: "Messages",
  components: {
    Message,
  },
  props: {
    messages: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
